export default __webpack_public_path__ + "static/media/224.51b5af95.png";